export const openDrawer = () => dispatch => dispatch({
  type: 'OPEN_DRAWER',
})

export const closeDrawer = () => dispatch => dispatch({
  type: 'CLOSE_DRAWER',
})

export const removeSnack = () => dispatch => dispatch({
  type: 'REMOVE_SNACK',
})

export const setSnackError = message => dispatch => dispatch({
  type: 'SNACK_ERROR',
  message: `Error: ${message}`,
})

export const setSnackSuccess = message => dispatch => dispatch({
  message,
  type: 'SNACK_SUCCESS',
})

export const closeModal = () => dispatch => dispatch({
  type: 'CLOSE_MODAL',
})

export const navigate = pathname => dispatch => dispatch({
  pathname,
  type: 'NAVIGATION',
})

export const loading = () => dispatch => dispatch({ type: 'LOADING' })

export const unload = () => dispatch =>  dispatch({ type: 'UNLOAD' })


export const navigateToUserPage = (userId, target) => (dispatch) => {
  const pathname = `/admin/user/${userId}`

  if (target) {
    return window.open(pathname, target)
  }

  return dispatch({
    pathname,
    type: 'NAVIGATION',
  })
}


export const navigateToCastingPage = castingId => dispatch => dispatch({
  type: 'NAVIGATION',
  pathname: `/admin/castings/${castingId}`,
})
